module.exports = __webpack_public_path__ + "static/ben-7003054c533d7c942b3c07ecd4e5a68f.png";